<template>
  <div class="medic-form">
    <div class="breadcrumb">
      <i class="fa fa-home"></i> Estás en:
      <router-link :to="{name: 'patients'}">Pacientes</router-link>/ Nuevo paciente
    </div>
    <div class="wrapper-form clearfix">
      <div class="form-title">
        <div class="text-bold">
          <i class="fas fa-edit u-black-light"></i> Nuevo paciente
        </div>
      </div>
      <div class="form-wrapper">
        <div class="form-group">
          <label class="form-label">Nombre del paciente</label>
          <input class="form-input" v-model="patient.name" />
        </div>
        <div class="form-group">
          <label class="form-label">Wallet</label>
          <input class="form-input" v-model="patient.wallet" />
        </div>
        <div class="form-group">
          <label class="form-label">Dirección</label>
          <input class="form-input" v-model="patient.homeAddress" />
        </div>
        <button type="button" class="btn btn-primary float-right" v-on:click="send">Enviar</button>
      </div>
    </div>
  </div>
</template>


<script>
import PatientsManager from "../managers/patientsManager";
import Swal from "sweetalert2";
export default {
  components: {},
  data() {
    return {
      patient: {
        name: "",
        wallet: "",
        homeAddress: "",
        date: ""
      },
      files: []
    };
  },
  methods: {
    deploy() {
      return new Promise(resolve => {
        this.patient.date = new Date().getTime();
        PatientsManager.CreatePatient(this.patient).then(() => {
          resolve(true);
        });
      });
    },
    send() {
      Swal.fire({
        title: "¿Estás seguro?",
        showCancelButton: true,
        confirmButtonText: "Sí",
        showLoaderOnConfirm: true,
        preConfirm: this.deploy,
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => {
        if (result.value) {
          Swal.fire({
            title: `¡Creado!`
          });

          this.$router.push({ name: "patients" });
        }
      });
    }
  },
  async created() {}
};
</script>